// extracted by mini-css-extract-plugin
export default {"yj-font-style":"yj-font-style--eonnx","yj_cp_masterlayout_wrapper":"yj_cp_masterlayout_wrapper--KGNsU"};